export const BREAKPOINTS = {
  mqDesktop: 1440,
  mqTouch: 992,
  mqTablet: 768,
  mqMobile: 375,
};
